import {Alert} from "@mui/material";

export default function RightGuard({canPass = false, children}) {
    return (

        <>

            {
                canPass
                    ? <>{children}</>
                    : <Alert severity="error">Vous n'avez pas accès à ce module!</Alert>
            }

        </>

    )
}